import { Component, OnInit, Input, Output, HostListener } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConnectionService } from 'src/app/services/core/api-connection.service';

import { ModalAnswersOverviewComponent } from '../modal-answers-overview/modal-answers-overview.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalAnswersOverviewStudentComponent } from '../modal-answers-overview-student/modal-answers-overview-student.component';

import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
	selector: 'app-modal-answers-overview-question',
	templateUrl: './modal-answers-overview-question.component.html',
	styleUrls: ['./modal-answers-overview-question.component.scss']
})
export class ModalAnswersOverviewQuestionComponent implements OnInit {
	@Input() public title;
	@Input() public questionId;
	@Input() public questionIds;
	@Input() public classroomId;
	@Input() public chapterLesson;
	@Input() public studentId;
	@Output() passEntry: EventEmitter<any> = new EventEmitter();

	showContent = true;
	showPictures = true;
	showAssignments = true;
	showAssignmentLines = true;

	showTerms = true;
	showDefinitions = true;
	showDefinitionLines = true;

	hideNames = true;
	hideAnswers = true;

	answerData: any;

	question: any;

	studentList: any = [];

	hidden = false;

	questionHeaders: any = null;
	classroomDetails: any = {};

	constructor(
		public activeModal: NgbActiveModal,
		public apiConnectionService: ApiConnectionService,
		private modalService: NgbModal,
		private loader: NgxUiLoaderService
	) { }

	@HostListener('window:keyup.esc', ['$event'])
	onKeyUp(event: KeyboardEvent) {
		this.close();
	}

	public extractNumbers(str, index) {
		const regex = /^(\d+\.|[a-z]+\))/i;
		const match = str.match(regex);
		return match ? match[0] : index;
	}

	ngOnInit(): void {
		this.setupData();
	}

	isEmailValid(email: string): boolean {
		// Regular expression to validate email addresses
		const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

		return emailPattern.test(email);
	}

	getFilteredQuestions(): any[] {
		if (!this.questionId || this.questionHeaders == null) {
			return [];
		}

		const index = this.questionHeaders.findIndex(
			(question) => question['questionId'] === this.questionId
		);

		const start = Math.max(0, index - 1);
		const end = Math.min(index + 2, this.questionHeaders.length - 1);

		return this.questionHeaders.slice(start, end + 1);
	}

	getIndex(question: any): number {
		return this.questionHeaders.findIndex(
			(q) => q['questionId'] === question['questionId']
		);
	}

	isNotLastQuestion(id) {
		if(this.questionHeaders[this.questionHeaders.length - 1].questionId == id) {
			return false;
		} else {
			return true;
		}
	}

	isNotFirstQuestion(id) {
		if(this.questionHeaders[0].questionId == id) {
			return false;
		} else {
			return true;
		}
	}

	private setupData() {

		this.apiConnectionService.read("classrooms/details/" + this.classroomId).then((data) => {
			this.classroomDetails = data;
		});

		const self = this;
		this.apiConnectionService.read('answers/question/' + this.chapterLesson['lesson']['id'] + "/" + this.classroomId + "/" + this.questionId).then((response) => {
			self.answerData = response;

			//add question answers
			this.questionHeaders = [];
			let tempHeaders = Object.values(self.answerData.questions);

			for (let i = 0; i < tempHeaders.length; i++) {
				this.questionHeaders.push(tempHeaders[i]);
			}

			for (let i = 0; i < tempHeaders.length; i++) {
				if (tempHeaders[i]['questionId'] == self.questionId) {
					self.question = tempHeaders[i];
				}
			}

		});
	}

	confirm() {
		this.activeModal.close({
			showContent: this.showContent,
			showPictures: this.showPictures,
			showAssignmentLines: this.showAssignmentLines,
			showAssignments: this.showAssignments,
			showTerms: this.showTerms,
			showDefinitions: this.showDefinitions,
			showDefinitionLines: this.showDefinitionLines
		});
	}

	cancel() {
		this.activeModal.close(false);
	}

	close() {
		this.modalService.dismissAll();
	}

	back() {
		this.activeModal.close(false);
	}

	backToOverview(state) {
		if (state == true) {
			const base: any = document.getElementsByClassName("answersOverview ")[0];
			base.style.opacity = "1";
		}
		this.activeModal.close(state);
	}

	showQuestionOverview(questionId: any) {
		this.questionId = questionId;
		this.setupData();
	}

	openStudentOverview(student) {
		const self = this;

		this.loader.start();

		setTimeout(function () {
			const studentOverviewModal = self.modalService.open(ModalAnswersOverviewStudentComponent, { size: 'lg', backdrop: false });
			studentOverviewModal.componentInstance.studentId = student['studentId'];
			studentOverviewModal.componentInstance.title = self.title;
			studentOverviewModal.componentInstance.studentName = student['studentName'];
			studentOverviewModal.componentInstance.chapterLesson = self.chapterLesson;
			studentOverviewModal.componentInstance.classroomId = self.classroomId;
			studentOverviewModal.componentInstance.questionIds = self.questionIds;

			setTimeout(function () {
				self.activeModal.close();
				self.loader.stop();
			}, 1000);
		}, 200);
	}

	updateAnswerState(newVal, data, studentId) {
		let answerData = {
			userId: studentId,
			questionId: this.questionId,
			questionStatus: newVal
		}

		this.apiConnectionService.save('users/answer/status', answerData).then((response) => {
			this.setupData();
		}).catch(function (e) {
		});
	}
}